module.exports = __webpack_public_path__ + "@/assets/img/profile.a378a9e9.png";